import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
});

const SidebarSubtitle = ({
  className,
  classes,
  title,
}) => {
  return (
    <Typography
      className={classNames(classes.root, className)}
      variant={'h5'}
      weight={'bold'}
      color={'primary'}
    >
      {title}
    </Typography>
  );
};

SidebarSubtitle.defaultProps = {
  className: '',
};

SidebarSubtitle.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(SidebarSubtitle);
